import * as Sentry from '@sentry/react';
import { Routes, Route } from 'react-router-dom';

import { ENTERPRISE_LOGIN_LOGOUT_PATH } from './common/constants';
import { AnnotationToolAppPageLayoutContainer } from './components/AnnotationToolAppPageLayoutContainer';
import { AnnotationToolUiRoutes } from './core/routes/annotation-tool-routes';
import { useSentry } from './hooks/useSentry';
import { LogoutPage } from './pages';

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export function App() {
  useSentry();
  return (
    <SentryRoutes>
      <Route path={ENTERPRISE_LOGIN_LOGOUT_PATH} element={<LogoutPage />} />
      <Route path="*" element={<AnnotationToolAppPageLayoutContainer />}>
        <Route path={`*`} element={<AnnotationToolUiRoutes />} />
      </Route>
    </SentryRoutes>
  );
}
